import React, { PureComponent } from "react";
import PropTypes from "prop-types";

import { CONTACT_US } from "npmlinks-constants";
import EmailInput from "../EmailInput";
import UserNameInput from "../UserNameInput";

class ContactUsFormElementDecider extends PureComponent {
  render() {
    const { userName, userEmail, isUserLoggedIn } = this.props;
    if (isUserLoggedIn) {
      return null;
    }
    return (
      <div>
        <div className="nw-contactusform-label"> {CONTACT_US.label1} </div>
        <div>
          <UserNameInput.component
            className="nw-contactusform-input"
            id="contactusnamefield"
            name="contactusnamefield"
            placeholder=""
            text={userName}
            validateUserNameInput={this.props.validateUserNameInput}
            required
          />
        </div>
        <div className="nw-contactusform-label"> {CONTACT_US.label2} </div>
        <div>
          <EmailInput.component
            className="nw-contactusform-input"
            name="contactusemailfield"
            id="contactusemailfield"
            placeholder=""
            text={userEmail}
            validateEmailInput={this.props.validateEmailInput}
            required
          />
        </div>
      </div>
    );
  }
}

ContactUsFormElementDecider.propTypes = {
  userEmail: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  validateEmailInput: PropTypes.func.isRequired,
  validateUserNameInput: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: ContactUsFormElementDecider,
  component: ContactUsFormElementDecider,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/V1/ContactUsFormElementDecider/index.js